import { PageName } from 'lib/constants';
import { useSession } from 'lib/requests/session';
import { ISession } from 'lib/types/session';
import { ReactNode } from 'react';
import { AuthContext } from './context';
import {
  getIsFeatureEnabledForCompany,
  getIsPageAccessibleToUser,
  getIsUserInPermission,
  getIsUserInternalAdmin,
} from './helpers';
import { FeatureName, PermissionName } from './types';

interface IAuthContextProviderProps {
  children: ReactNode;
  session: ISession | undefined;
}

export const AuthContextProvider = ({
  children,
  session: passedSession,
}: IAuthContextProviderProps) => {
  const { data: refreshedSession, mutate: refreshSession } = useSession({
    revalidateOnMount: false,
    shouldFetch: !!passedSession,
  });
  const session = refreshedSession ?? passedSession;

  return (
    <AuthContext.Provider
      value={{
        getIsFeatureEnabled: (featureName: FeatureName) =>
          getIsFeatureEnabledForCompany(featureName, session),
        getIsInPermission: (allowed: PermissionName) =>
          getIsUserInPermission(allowed, session),
        getIsPageAccessible: (pageName: PageName) =>
          getIsPageAccessibleToUser(pageName, session),
        isInternalAdmin: getIsUserInternalAdmin(session),
        refreshSession,
        session,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
